import React from 'react';
import { useHistory } from 'react-router-dom';

import './no-product-style.scss';

import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

import { searchUrl } from '@src/app/routes';

interface NoProductProps {
  isSearchResult?: boolean;
}

const NoProduct = ({ isSearchResult }: NoProductProps) => {
  const history = useHistory();

  return (
    <div id="no-product-wrapper">
      <Typography variant="body2" component="p" style={{ color: '#666666' }}>
        Sorry, no items found for your request
      </Typography>
      <Typography variant="body2" component="p" style={{ color: '#666666' }}>
        Try again or shop new arrivals
      </Typography>

      {isSearchResult && (
        <Button cName="search-again-btn" variant="outlined" size="medium" onClick={() => history.push(searchUrl)}>
          Search again
        </Button>
      )}
    </div>
  );
};

export default NoProduct;
